module.exports = __webpack_public_path__ + "img/howard-profile-image.d12d2f8b.webp";